// extracted by mini-css-extract-plugin
export var contrastLow = "_40-1";
export var externalLink = "_40-2";
export var externalLinkIcon = "_40-3";
export var link = "_40-0";
export var linkLabel = "_40-4";